import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Button, FormControl, Input, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@material-ui/core";
import {KeyboardDatePicker} from "@material-ui/pickers";
import moment from "moment-timezone";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import CustomLabel from "../../../../Common/CustomLabel";
import t from "../../../../../languages/pl";
import { buttonStyle } from "../buttonGroupStyle";
import { themeTypeToBool } from '../../../../../utils/helpers';
import { calcDurationFromEpoch } from './../../../../../utils/helpers';
import { displayDateFormat, dateTimePickerFormat } from "../../../../../utils/staticData";
import { compose } from 'recompose';
import withSubordinateUser from './../../../../HOC/withSubordinateUser';

const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(3)
    },
    row: {
        display: "flex",
        alignItems: "center",
    },
    formField: {
        margin: theme.spacing(1),
        width: 200
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    }
});

const ContractedMileageMonitor = props => {
    const { classes, name, data: input, onDialogOpen, onSubmit, nonAdminUser } = props;
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(input);
    const [overMileage, setOverMileage] = useState("");

    useEffect(() => {
        setData(input);
        //FIXME
        if (input.przekroczenie_przebiegu === 0) {
            setOverMileage(0);
        } else {
            setOverMileage(
                Math.floor(((input.przekroczenie_przebiegu - input.prawidlowy_przebieg) / input.prawidlowy_przebieg) * 100).toString() + "%"
            );
        }
    }, [input]);

    const handleStartTimeChange = (e) => {
        let newDate = moment(e).unix();
        let duration = calcDurationFromEpoch(newDate, data.koniec_kontraktu);
        setData({
            ...data,
            poczatek_kontraktu: newDate,
            ilosc_dni_kontraktu: duration.asDays() > 0 ? Math.floor(duration.asDays()) : 0
        });
    };

    const handleEndTimeChange = (e) => {
        let newDate = moment(e).unix();
        let duration = calcDurationFromEpoch(data.poczatek_kontraktu, newDate);
        setData({
            ...data,
            koniec_kontraktu: newDate,
            ilosc_dni_kontraktu: duration.asDays() > 0 ? Math.floor(duration.asDays()) : 0
        });
    };

    const handleDialogOpen = () => {
        if(onDialogOpen)
            onDialogOpen();
        setOpen(true);
    };

    const handleSubmit = () => {
        setOpen(false);
        if(onSubmit)
            onSubmit(data);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.contractedMileageMonitor}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="md"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.contractedMileageMonitorTitle} {name}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.container}>
                        <div className={classes.row}>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.contractedMileage}
                                </CustomLabel>
                                <Input
                                    value={data.zakontraktowany_przebieg}
                                    onChange={(e) => setData({...data, zakontraktowany_przebieg: e.target.value})}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.row}>
                            <KeyboardDatePicker
                                className={classes.formField}
                                label={t.contractStart}
                                invalidDateMessage={t.invalidDateFormat}
                                InputLabelProps={{
                                    shrink: true,
                                    classes: { root: classes.label }
                                }}
                                ampm={false}
                                variant="inline"
                                format={displayDateFormat}
                                value={data.poczatek_kontraktu === 0 ? null : moment.unix(data.poczatek_kontraktu).format(dateTimePickerFormat)}
                                onChange={handleStartTimeChange}
                            />
                            <KeyboardDatePicker
                                className={classes.formField}
                                label={t.contractEnd}
                                invalidDateMessage={t.invalidDateFormat}
                                InputLabelProps={{
                                    shrink: true,
                                    classes: { root: classes.label }
                                }}
                                ampm={false}
                                variant="inline"
                                format={displayDateFormat}
                                value={data.koniec_kontraktu === 0 ? null : moment.unix(data.koniec_kontraktu).format(dateTimePickerFormat)}
                                onChange={handleEndTimeChange}
                            />
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.totalDaysContract}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.ilosc_dni_kontraktu}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.row}>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.estimatedDailyMileage}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.planowany_przebieg_dzienny}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.row}>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.currentDate}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={moment.unix(data.aktualna_data).format("DD-MM-YYYY")}
                                />
                            </FormControl>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.currectContractMileage}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.aktualny_przebieg}
                                />
                            </FormControl>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.currentMileageState}
                                </CustomLabel>
                                {/*//FIXME brak danych o dystansie */}
                                <Input
                                    disabled
                                    value={data.dystans}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.row}>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.contractDayCount}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.ktory_dzien_kontraktu}
                                />
                            </FormControl>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.correctContractMileage}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.prawidlowy_przebieg}
                                />
                            </FormControl>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.contractExceededMileage}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={data.przekroczenie_przebiegu}
                                />
                            </FormControl>
                            <FormControl className={classes.formField}>
                                <CustomLabel>
                                    {t.percentageOverMileage}
                                </CustomLabel>
                                <Input
                                    disabled
                                    value={overMileage}
                                />
                            </FormControl>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        onSubmit={handleSubmit}
                        disableSubmit={nonAdminUser}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default compose(
    withStyles(useStyles),
    withSubordinateUser
)(ContractedMileageMonitor);

ContractedMileageMonitor.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    data: PropTypes.object,
    onDialogOpen: PropTypes.func,
    onSubmit: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};